const ro = {
    Dashboard: 'Administrare',
    Bidding: 'Ofertare',
    Hello: 'Salut',
    'Welcome to the platform': 'Bine ai venit pe platformă',
    'General administration': 'Administrare generală',
    'Unit features': 'Caracteristici unități',
    'SEE OBJECTIVES': 'VEZI OBIECTIVE',
    'Deliveries IP': 'Livrari PF',
    'Deliveries LP': 'Livrari PJ',
    'Electric deliveries': 'Livrari Electrice',
    'Electric Controls': 'Comenzi Electrice',
    'Thermal Controls': 'Comenzi Termice',
    'Hybrid orders': 'Comenzi Hibrid',
};

export default { ro };
